import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { motion } from "framer-motion";
import { getData } from "../../Webservice/Webservice";

function FAQs() {
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      const res = await getData("faq/list");
      if (res && res.topic) {
        setFaqData(res.topic);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  return (
    <Box
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 4, md: 8 },
        maxWidth: "1000px",
        mx: "auto",
      }}
    >
      {/* Page Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "28px", sm: "36px", md: "44px" },
            color: "#1a1a1a",
            fontWeight: 700,
            textAlign: "center",
            letterSpacing: "1px",
            mb: 2,
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            color: "#555",
            mb: 6,
            maxWidth: "700px",
            mx: "auto",
          }}
        >
          Find quick answers to common questions about your account, billing,
          and platform usage.
        </Typography>
      </motion.div>

      {/* FAQ Sections */}
      {faqData.map((section, index) => (
        <motion.div
          key={section.id || index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1, duration: 0.4 }}
        >
          <Box
            sx={{
              mb: 5,
              bgcolor: "#919090ff",
              overflow: "hidden",
              border: "1px solid black",
            }}
          >
            <Box
              sx={{
                bgcolor: "#f7f9fc",
                px: 3,
                py: 2,
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {section.name}
              </Typography>
            </Box>

            {section.faqs.map((faq, i) => (
              <Accordion
                key={faq._id || i}
                disableGutters
                sx={{
                  boxShadow: "none",
                  borderBottom: "1px solid #eee",
                  "&:before": { display: "none" },
                  "&:hover": {
                    bgcolor: "#fafafa",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#666" }} />}
                  sx={{
                    px: 3,
                    py: 1,
                  }}
                >
                  <Typography sx={{ fontWeight: 500, color: "#333" }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ px: 3, pb: 2 }}>
                  <Typography sx={{ color: "#555", lineHeight: 1.7 }}>
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </motion.div>
      ))}
    </Box>
  );
}

export default FAQs;
